const WebFont = require('webfontloader');

WebFont.load({
  google: {
    families: [
        'Montserrat:400,500,700,900',
    ],
  },
});



// WEBPACK FOOTER //
// ./scripts/google-fonts.js